import { Component, Lifecycle } from "vuety";
import { Prop } from "vuety";
import { IProductGroupItem } from "../../interfaces";
import { TreeList } from "./treeList";
import { BaseView } from "../base";
import Vue from "vue";

const templateElement = "v-tmpl-grouptreeitem";

@Component({
	template: document.getElementById(templateElement) ? "#" + templateElement : require("./treeItem.html"),
	name: "tree-item",
	mixins: [BaseView],
})
export class TreeItem extends Vue {
	@Prop() public group: IProductGroupItem;
	@Prop() public parentGroupCode: string;

	public get isVisible(): boolean {
		// item is visible if its parent is the current group, or it is the current group, or it contains a list that is visible
		return (
			this.currentGroup === this.parentGroupCode ||
			this.currentGroup === this.group.GroupCode ||
			(this.$refs["treeList"] as TreeList).isVisible
		);
	}

	@Lifecycle()
	beforeCreate() {
		if (this.$options && this.$options.components) {
			this.$options.components["TreeList"] = TreeList;
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/tree/treeItem.ts